export const isSimplifiedTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  transactionType.charAt(1) === "1";
